import { Box, Card, CardContent, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.50",
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 448, mx: 2 }}>
        <CardContent sx={{ pt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <ErrorOutlineIcon sx={{ width: 32, height: 32, color: "error.main" }} />
            <Typography variant="h5" sx={{ fontWeight: 700 }} color="text.primary">
              404 Page Not Found
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            Did you forget to add the page to the router?
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
